import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { withTranslation } from "react-i18next";
import companyName from "../../../store/mobxStore/companyName";
import Forms from "../../components/auth/Forms";
import ForgotPasswordService from "../../../service/Auth/ForgotPassowrd";
import { AlertMessage } from "../../components/common";
import { useParams, useHistory } from "react-router-dom";
import SubmitButton from "../../components/QRCode/SubmitButton";

function QRCode({ t }) {
  const history = useHistory();
  const params = useParams();
  console.log({ params });
  const [loading, setLoading] = useState(false);

  let styles = {
    marginTop: "-1px",
    marginLeft: "23px",
    color: "#a94442",
    fontSize: "12px",
  };
  const service = new ForgotPasswordService();

  const notifyInintialState = {
    show: false,
    message: "",
    type: "",
    header: "",
  };

  const [state, setState] = useState({
    ticketNumber: params.ticket_number ?? "",
    authorizationCode: "",
    notify: notifyInintialState,
    FormError: {
      authorizationCode: "",
    },
    btnDisabled: false,
  });
  const [show, setShow] = useState(false);

  const formValid = (formError) => {
    console.log(formError);
    let valid = true;
    Object.values(formError).forEach((val) => console.log(val));
    console.log(valid);
    return valid;
  };

  const onchangeHandler = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const requiredValid = (value, name) => {
    const FormError = state.FormError;
    switch (name) {
      case "authorizationCode":
        FormError.authorizationCode =
          value.length === 0 ? "authorizationCodereq" : "";
        break;
    }

    setState((prevState) => ({
      ...prevState,
      FormError,
    }));
  };

  const onSubmit = async (e) => {
    e.preventDefault(); //prevent default
    requiredValid(state.authorizationCode, "authorizationCode");
    if (state.FormError.authorizationCode.length == 0) {
      const formData = {
        authorizationCode: state.authorizationCode,
        ticketNumber: state.ticketNumber,
      };
      service.approveQrCode(formData).then((res) => {
        console.log({ res });
        if (!res.status) {
          console.log(res.error);
          showNotify("danger", t("Common.error"), t(res.error.description));
        } else if (res.data && res.data.message) {
          showNotify("success", t("Common.success"), t(res.data.message));
          setTimeout(() => {
            window.location.reload();
          }, 2500);
        } else {
          showNotify(
            "danger",
            t("Common.error"),
            t("validation.invalidCaptcha")
          );
        }
      });
    }
  };

  const showNotify = (type, header, message) => {
    setState((prev) => ({
      ...prev,
      notify: {
        ...prev.notify,
        show: true,
        type: type,
        header: t(header),
        message: t(message),
      },
    }));
  };

  const notifyDissmissed = () => {
    setState((prev) => ({
      ...prev,
      notify: notifyInintialState,
    }));
  };

  return (
    <>
      <div className="mb-2">
        <Helmet>
          <title>
            {companyName.companyName} {t("Common.QRCode")}
          </title>
        </Helmet>

        {state.notify.show && (
          <AlertMessage
            type={state.notify.type}
            message={state.notify.message}
            show={state.notify.show}
            dismiss={notifyDissmissed}
          />
        )}
        {/* <form id="forgot-form"> */}
        <p style={{ textAlign: "center", marginBottom: "1em" }}>
          Please enter your authorization code
        </p>
        <Forms
          type="text"
          name="authorizationCode"
          change={onchangeHandler}
          error={state.FormError.authorizationCode}
        />
        <SubmitButton submit={onSubmit} disabled={state.btnDisabled} />
        {/* </form> */}
      </div>
    </>
  );
}
export default withTranslation()(QRCode);
